import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "Routes";
import * as serviceWorker from "serviceWorker";

import configureStore from "./store";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { GoogleOAuthProvider } from "@react-oauth/google";
import "index.scss";

const initialState = {};
// const store = configureStore(initialState);
const { store, persistor } = configureStore(initialState);
ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <Router>
          <PersistGate loading={null} persistor={persistor}>
            <Routes />
          </PersistGate>
        </Router>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,

  document.getElementById("root")
);

// Register service worker for PWA functionality
// This is required for the install prompt to appear
serviceWorker.register();

// Register Firebase service worker for push notifications
serviceWorker.registerFirebaseServiceWorker();
